import cloverImage from "../../../assets/img/NotificacionesModales/cloverDesktop.png";
import verifoneImage from "../../../assets/img/verifone.png";

const MODEL_RULES = [
  {
    key: "clover-flex-3",
    brand: "CLOVER",
    model: "Clover Flex",
    generation: "3ra generacion",
    rule: "ID C045",
    image: cloverImage,
    matches: ({ idClover }) => String(idClover || "").toUpperCase().startsWith("C045"),
  },
  {
    key: "clover-flex-4",
    brand: "CLOVER",
    model: "Clover Flex",
    generation: "4ta generacion",
    rule: "ID C046",
    image: cloverImage,
    matches: ({ idClover }) => String(idClover || "").toUpperCase().startsWith("C046"),
  },
  {
    key: "clover-mini",
    brand: "CLOVER",
    model: "Clover Mini",
    generation: "Sin generacion informada",
    rule: "ID C305",
    image: cloverImage,
    matches: ({ idClover }) => String(idClover || "").toUpperCase().startsWith("C305"),
  },
  {
    key: "verifone",
    brand: "VERIFONE",
    model: "Verifone",
    generation: "Modelo operativo",
    rule: "Terminal 39",
    image: verifoneImage,
    matches: ({ terminal }) => String(terminal || "").startsWith("39"),
  },
];

export const PROVINCIAL_CARDS = [
  { key: "titanio", label: "Titanio" },
  { key: "naranja", label: "Naranja" },
  { key: "credicash", label: "Credicash" },
];

export const BAJA_MOTIVOS = [
  { value: "BAJA", label: "Baja" },
  { value: "BAJA POR FACTURACION", label: "Baja por facturacion" },
  { value: "BAJA POR POSNET", label: "Baja por Posnet" },
  { value: "BAJA POR CAMBIO DE TERMINAL", label: "Baja por cambio de terminal" },
];

export function identifyDeviceModel(terminalDetails = {}) {
  const normalized = {
    terminal: String(terminalDetails.nDeTerminal || terminalDetails.NDeTerminal || terminalDetails.terminal || "").trim(),
    idClover: String(terminalDetails.idClover || terminalDetails.IdClover || "").trim(),
  };

  const matched = MODEL_RULES.find((rule) => rule.matches(normalized));
  if (matched) {
    return {
      recognized: true,
      brand: matched.brand,
      model: matched.model,
      generation: matched.generation,
      rule: matched.rule,
      image: matched.image,
      key: matched.key,
    };
  }

  return {
    recognized: false,
    brand: "SIN DATOS",
    model: "Modelo no identificado",
    generation: "Sin datos",
    rule: normalized.idClover ? `ID ${normalized.idClover.slice(0, 4).toUpperCase()}` : "Sin regla",
    image: null,
    key: "unknown",
  };
}
